import React from 'react'

const MicrositingWhitepaperPage = () => {
 return (
    <div
      style={{
        margin: 0,
        padding: 0,
        height: "100vh",
        width: "100vw",
        overflow: "hidden",
      }}
    >
      <iframe
        title="Micrositing Whitepaper"
        loading="lazy"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
        src="https://www.canva.com/design/DAGzTjG-W2A/qQ3HSOKZOPRD9SwkceEMhg/view?embed"
        allowFullScreen
      ></iframe>
    </div>
  );
}

export default MicrositingWhitepaperPage





